"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8018],{

/***/ 64370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54444);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);




var TextWithIcon = function TextWithIcon(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
      mx: "-5px",
      alignItems: "center",
      justifyContent: props.rightSideIcon ? 'space-between' : 'normal',
      style: { width: props.rightSideIcon ? '100%' : 'auto' },
      className: props.className, children: [

      props.rightSideIcon ? null : /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mx: "5px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          name: props.icon,
          color: props.iconColor,
          fontSize: props.iconSize,
          style: { verticalAlign: 'middle' } }) }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        as: "p",
        mx: "5px",
        style: { textTransform: props.uppercase ? 'uppercase' : 'inherit' }, children:

        props.children }),

      props.rightSideIcon ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mx: "5px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          name: props.icon,
          color: props.iconColor,
          fontSize: props.iconSize }) }) :


      null] }));};



/* harmony default export */ __webpack_exports__["Z"] = (TextWithIcon);

/***/ }),

/***/ 9310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox_Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckBox.js
var CheckBox = __webpack_require__(62810);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckBoxOutlineBlank.js
var CheckBoxOutlineBlank = __webpack_require__(17149);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./lib/theme.ts
var theme = __webpack_require__(62594);
// EXTERNAL MODULE: ./components/form/Label.js
var Label = __webpack_require__(25077);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/form/checkbox/Label.js




var styles = {
  label: {
    fontSize: '13px' } };



/* harmony default export */ var checkbox_Label = ((0,withStyles/* default */.Z)(styles)(function (props) {return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
      label: props.label,
      style: {
        marginLeft: 0,
        marginRight: 0,
        height: '100%' },

      control: props.children,
      classes: {
        label: props.classes.label } }));}));
;// CONCATENATED MODULE: ./components/form/checkbox/Checkbox.js
function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = (0,getPrototypeOf/* default */.Z)(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return (0,possibleConstructorReturn/* default */.Z)(this, result);};}function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}









var Wrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "Checkbox__Wrapper", componentId: "sc-v08t68-0" })([""]);

var Checkbox_styles = {
  root: {
    position: 'relative',
    /* when checked margin is added which makes elements move a little bit, so we force it here */
    margin: '0 10px 0 0',
    color: '#eeeeee',
    width: '15px',
    marginRight: '7px',
    height: '100%',
    '&$checked': {
      color: theme/* default.colors.primary.blue-2 */.Z.colors.primary["blue-2"] },

    '&:hover': {
      backgroundColor: 'transparent !important' } },


  checked: {},
  sizeIcon: {
    fontSize: 20 } };var



Checkbox = /*#__PURE__*/function (_Component) {(0,inherits/* default */.Z)(Checkbox, _Component);var _super = _createSuper(Checkbox);function Checkbox() {var _this;(0,classCallCheck/* default */.Z)(this, Checkbox);for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}_this = _super.call.apply(_super, [this].concat(args));(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state",
    {
      isChecked: false });(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "handleChange",


    function (e) {
      if (typeof _this.props.onChange === 'function') {
        _this.props.onChange(e);
      }
    });return _this;}(0,createClass/* default */.Z)(Checkbox, [{ key: "render", value:







    function render() {
      var _this$props =



      this.props,_this$props$dataTest = _this$props['data-testid'],dataTestId = _this$props$dataTest === void 0 ? 'Checkbox' : _this$props$dataTest,className = _this$props.className,_this$props$required = _this$props.required,required = _this$props$required === void 0 ? false : _this$props$required;
      if (this.props.label) {
        return /*#__PURE__*/(
          (0,jsx_runtime.jsx)(Wrapper, {
            className: className,
            style: this.props.style, children: /*#__PURE__*/


            (0,jsx_runtime.jsx)(checkbox_Label, { label: this.props.label, children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(Checkbox_Checkbox/* default */.Z, {
                checked: this.props.isChecked,
                onChange: this.handleChange,
                classes: {
                  root: this.props.classes.root,
                  checked: this.props.classes.checked },

                icon: /*#__PURE__*/
                (0,jsx_runtime.jsx)(CheckBoxOutlineBlank/* default */.Z, {
                  className: this.props.classes.sizeIcon }),


                checkedIcon: /*#__PURE__*/
                (0,jsx_runtime.jsx)(CheckBox/* default */.Z, { className: this.props.classes.sizeIcon }),

                required: required }) }) }));




      } else {
        return /*#__PURE__*/(
          (0,jsx_runtime.jsx)(Wrapper, {
            className: className,
            style: this.props.style, children: /*#__PURE__*/


            (0,jsx_runtime.jsx)(checkbox_Label, {
              label: /*#__PURE__*/
              (0,jsx_runtime.jsx)(Label/* TypographyCheckbox */.x, { labelColor: this.props.labelColor, children:
                this.props.children }), children: /*#__PURE__*/



              (0,jsx_runtime.jsx)(Checkbox_Checkbox/* default */.Z, {
                name: this.props.name,
                htmlFor: this.props.htmlFor,
                id: this.props.id,
                checked: this.props.isChecked,
                onChange: this.handleChange,
                onBlur: this.handleBlur,
                classes: {
                  root: this.props.classes.root,
                  checked: this.props.classes.checked },

                icon: /*#__PURE__*/
                (0,jsx_runtime.jsx)(CheckBoxOutlineBlank/* default */.Z, {
                  className: this.props.classes.sizeIcon }),


                checkedIcon: /*#__PURE__*/
                (0,jsx_runtime.jsx)(CheckBox/* default */.Z, { className: this.props.classes.sizeIcon }),

                required: required }) }) }));




      }
    } }], [{ key: "getDerivedStateFromProps", value: function getDerivedStateFromProps(props) {return { isChecked: props.isChecked };} }]);return Checkbox;}(react.Component);


/* harmony default export */ var checkbox_Checkbox = ((0,withStyles/* default */.Z)(Checkbox_styles)(Checkbox));

/***/ }),

/***/ 98648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(90116);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(4730);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(17674);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(94471);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(31157);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(85169);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(868);
/* harmony import */ var _material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(44080);
/* harmony import */ var _material_ui_icons_Public__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(80650);
/* harmony import */ var _material_ui_icons_VisibilityOff__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(28270);
/* harmony import */ var _organisms_modals_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10842);
/* harmony import */ var _components_form_checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9310);
/* harmony import */ var _components_typography_Headings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94268);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94007);
/* harmony import */ var _lib_apollo_policies__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54734);
/* harmony import */ var _components_TextWithIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64370);
/* harmony import */ var _organisms_modals_PlaylistModal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(24331);
/* harmony import */ var _lib_hooks_useLoginModal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(73074);
/* harmony import */ var _gql_generated__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48354);
/* harmony import */ var _lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47493);
/* harmony import */ var _lib_analytics_manager__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88224);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(85893);
var _excluded = ["data"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}





















var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_16__["default"])(_components_form_checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({ displayName: "ButtonAddtoPlaylist__Checkbox", componentId: "sc-vf6ck9-0" })(["margin-right:15px;.MuiCheckbox-root.MuiCheckbox-root{.MuiSvgIcon-root{padding:0;opacity:1;}}"]);











var EnhancedBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_16__["default"])(_organisms_modals_base__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT).withConfig({ displayName: "ButtonAddtoPlaylist__EnhancedBody", componentId: "sc-vf6ck9-1" })(["padding-right:0;max-height:300px;overflow:auto;@media (max-width:", "){flex:1;max-height:inherit;}"],



function (_ref) {var theme = _ref.theme;return "".concat(theme.viewports.tablet, "px");});





var EnhancedModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_16__["default"])(_organisms_modals_base__WEBPACK_IMPORTED_MODULE_4__/* .Modal */ .u_).withConfig({ displayName: "ButtonAddtoPlaylist__EnhancedModal", componentId: "sc-vf6ck9-2" })(["@media (max-width:", "){&&&{display:flex;flex-direction:column;}}"],
function (_ref2) {var theme = _ref2.theme;return "".concat(theme.viewports.tablet, "px");});







var ModalButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_16__["default"])(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z).withConfig({ displayName: "ButtonAddtoPlaylist__ModalButton", componentId: "sc-vf6ck9-3" })(["&&&{text-transform:uppercase;font-size:13px;font-weight:600;width:100%;border:none;border-top:1px solid #eee;padding:20px;background-color:#fff;}"]);












var ICON = function ICON(visibility) {
  switch (visibility) {
    case 'private':
      return /*#__PURE__*/(
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
          title: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_19__/* .Trans */ .cC, { id: "button_add_to_playlist.private", message: "private" }),

          placement: "top-start", children: /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, { style: { fillOpacity: 0.6 } }) }));


    case 'public':
      return /*#__PURE__*/(
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
          title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_19__/* .Trans */ .cC, { id: "button_add_to_playlist.public", message: "public" }),
          placement: "top-start", children: /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_material_ui_icons_Public__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, { style: { fillOpacity: 0.6 } }) }));


    case 'hidden':
      return /*#__PURE__*/(
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
          title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_19__/* .Trans */ .cC, { id: "button_add_to_playlist.hidden", message: "hidden" }),
          placement: "top-start", children: /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_material_ui_icons_VisibilityOff__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, { style: { fillOpacity: 0.6 } }) }));



    default:
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_material_ui_icons_VisibilityOff__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, { style: { fillOpacity: 0.6 } });}

};

var PAGE = 1;
var PERPAGE = 12;

var ButtonAddToPlaylist = function ButtonAddToPlaylist(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),isModalOpen = _useState[0],setModalOpen = _useState[1];
  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),fetching = _useState2[0],setFetching = _useState2[1];
  var _useLoginModal =


  (0,_lib_hooks_useLoginModal__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
    callBack: function callBack() {
      // TODO: handle this
      // we need to convert playlist to hook style first
    } }),_useLoginModal2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(_useLoginModal, 2),loginModalContent = _useLoginModal2[0],_useLoginModal2$ = _useLoginModal2[1],isOpen = _useLoginModal2$.isOpen,openLoginModal = _useLoginModal2$.openModal;


  // this should be probably globalized throught context
  // but what about perf?
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_13__/* .UserContext */ .S),currentUser = _useContext[0];

  // user is set to null when not authenticated, its undefined initially
  var isAuthenticated = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;

  var DynamicComponent = props.tag;
  var _useUserPlaylistsQuer =





  (0,_gql_generated__WEBPACK_IMPORTED_MODULE_12__/* .useUserPlaylistsQuery */ .$BZ)({
    ssr: false,
    variables: {
      id: null,
      page: PAGE,
      perPage: PERPAGE } }),loading = _useUserPlaylistsQuer.loading,error = _useUserPlaylistsQuer.error,data = _useUserPlaylistsQuer.data,fetchMore = _useUserPlaylistsQuer.fetchMore,refetchPlaylists = _useUserPlaylistsQuer.refetch;



  var _useAddVideoToPlaylis = (0,_gql_generated__WEBPACK_IMPORTED_MODULE_12__/* .useAddVideoToPlaylistMutation */ .PEq)(),_useAddVideoToPlaylis2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(_useAddVideoToPlaylis, 1),addVideoToPlaylist = _useAddVideoToPlaylis2[0];
  var _useRemoveVideoFromPl = (0,_gql_generated__WEBPACK_IMPORTED_MODULE_12__/* .useRemoveVideoFromPlaylistMutation */ .o1x)(),_useRemoveVideoFromPl2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(_useRemoveVideoFromPl, 1),removeVideoFromPlaylist = _useRemoveVideoFromPl2[0];

  var handleAddVideoToPlaylist = function handleAddVideoToPlaylist(playlistId) {
    (0,_lib_analytics_manager__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)().sendVideoAddToPlaylistEvent({
      video_id: props.videoId,
      playlist_id: playlistId });

    // TODO PLAYLIST: handle errors
    return addVideoToPlaylist({
      variables: {
        videoId: props.videoId,
        playlistId: playlistId },

      optimisticResponse: function optimisticResponse() {
        return {
          addVideoToPlaylist: { playlist: { id: playlistId } } };

      },
      update: function update(proxy) {
        var newVideo = { id: props.videoId, __typename: 'Video' };
        var _proxy$readQuery = proxy.readQuery({
          query: _gql_generated__WEBPACK_IMPORTED_MODULE_12__/* .UserPlaylistsDocument */ .Y5y,
          variables: { id: null, perPage: PERPAGE, page: PAGE } }),_userPlaylists = _proxy$readQuery.userPlaylists;

        var userPlaylists = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.cloneDeep)(_userPlaylists);
        userPlaylists.data = userPlaylists.data.map(function (playlist) {
          if (playlist.id === playlistId) {
            playlist.videos.push(newVideo);
          }
          return playlist;
        });
        proxy.writeQuery({
          query: _gql_generated__WEBPACK_IMPORTED_MODULE_12__/* .UserPlaylistsDocument */ .Y5y,
          data: { userPlaylists: userPlaylists },
          variables: { perPage: PERPAGE, page: PAGE } });

      } }).
    then(function () {
      (0,_lib_apollo_policies__WEBPACK_IMPORTED_MODULE_8__/* .snackbarVar */ .Ck)({
        isSnackBarOpen: true,
        snackBarMessage: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_24__/* .i18n._ */ .ag._("snackbars.added_video_playlist"),
        goTo: 'PLAYLIST',
        id: playlistId });

    });
  };

  var handleRemoveVideoFromPlaylist = function handleRemoveVideoFromPlaylist(playlistId) {
    // TODO PLAYLIST: HANDLE ERRORS
    return removeVideoFromPlaylist({
      variables: {
        videoId: props.videoId,
        playlistId: playlistId },

      optimisticResponse: function optimisticResponse() {
        return {
          removeVideoFromPlaylist: {
            playlist: {
              id: playlistId } } };



      },
      update: function update(proxy) {
        var _proxy$readQuery2 = proxy.readQuery({
          query: _gql_generated__WEBPACK_IMPORTED_MODULE_12__/* .UserPlaylistsDocument */ .Y5y,
          variables: { id: null, perPage: PERPAGE, page: PAGE } }),_userPlaylists = _proxy$readQuery2.userPlaylists;

        var userPlaylists = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.cloneDeep)(_userPlaylists);
        var mutatedPlaylist = userPlaylists.data.find(
        function (playlist) {return playlist.id === playlistId;});

        var videoIndex = mutatedPlaylist.videos.findIndex(
        function (video) {return video.id === props.videoId;});

        mutatedPlaylist.videos.splice(videoIndex, 1);
        userPlaylists.data = userPlaylists.data.map(function (playlist) {
          if (playlist.id === playlistId) {
            return mutatedPlaylist;
          }
          return playlist;
        });
        proxy.writeQuery({
          query: _gql_generated__WEBPACK_IMPORTED_MODULE_12__/* .UserPlaylistsDocument */ .Y5y,
          data: { userPlaylists: userPlaylists },
          variables: { perPage: PERPAGE, page: PAGE } });

      } }).
    then(function () {
      (0,_lib_apollo_policies__WEBPACK_IMPORTED_MODULE_8__/* .snackbarVar */ .Ck)({
        isSnackBarOpen: true,
        goTo: 'PLAYLISTS',
        snackBarMessage: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_24__/* .i18n._ */ .ag._("snackbars.removed_video_playlist"),
        id: playlistId });

    });
  };

  if (loading || error) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(DynamicComponent, { disabled: loading, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_19__/* .Trans */ .cC, { id: "metadata.please_wait", message: "Please wait..." }) }));


  }

  var userPlaylists = data === null || data === void 0 ? void 0 : data.userPlaylists;

  var handleAddToPlaylist = function handleAddToPlaylist(openPlaylistModal) {
    if (!userPlaylists || !isAuthenticated) {
      openLoginModal();
    } else if (userPlaylists.totalCount === 0) {
      openPlaylistModal();
    } else {
      setModalOpen(true);
    }
  };

  // const playlistsWithVideo = userPlaylists.data.filter(playlist =>
  //   playlist.videos.some(video => video.id === props.videoId)
  // );

  var handleShowMore = /*#__PURE__*/function () {var _ref3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
              setFetching(true);
              fetchMore({
                variables: {
                  page: userPlaylists.page + 1 },

                updateQuery: function updateQuery(prev, _ref4) {var fetchMoreResult = _ref4.fetchMoreResult;
                  if (!fetchMoreResult) return prev;
                  var _fetchMoreResult$user = fetchMoreResult.userPlaylists,newData = _fetchMoreResult$user.data,rest = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(_fetchMoreResult$user, _excluded);
                  setFetching(false);
                  return {
                    userPlaylists: _objectSpread({
                      data: [].concat((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(prev.userPlaylists.data), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(newData)) },
                    rest) };


                } });case 2:case "end":return _context.stop();}}}, _callee);}));return function handleShowMore() {return _ref3.apply(this, arguments);};}();



  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_organisms_modals_PlaylistModal__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        onModalClose: props.onModalClose,
        onCompletedStorePlaylist: /*#__PURE__*/function () {var _ref5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(playlistId) {return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (
                      handleAddVideoToPlaylist(playlistId));case 2:return _context2.abrupt("return",
                    refetchPlaylists());case 3:case "end":return _context2.stop();}}}, _callee2);}));return function (_x) {return _ref5.apply(this, arguments);};}(), children:


        function children(openPlaylistModal) {return /*#__PURE__*/(
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, { children: [/*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(DynamicComponent, {
                onClick: function onClick() {
                  handleAddToPlaylist(openPlaylistModal);
                }, children: /*#__PURE__*/

                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_TextWithIcon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, { icon: "ygb-icon-playlist", iconSize: "15px", children: /*#__PURE__*/
                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_19__/* .Trans */ .cC, { id: "menu_add_playlist.add", message: "Add to Playlist" }) }) }),


              userPlaylists && isModalOpen ? /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(EnhancedModal, {
                open: true,
                handleClose: function handleClose() {return setModalOpen(false);}, children: [/*#__PURE__*/


                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_organisms_modals_base__WEBPACK_IMPORTED_MODULE_4__/* .Header */ .h4, {
                  handleClose: function handleClose() {return setModalOpen(false);},
                  paddingBottom: 10, children: /*#__PURE__*/

                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, { as: _components_typography_Headings__WEBPACK_IMPORTED_MODULE_6__.H4, mt: "0px", mb: "0px", children: /*#__PURE__*/
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_19__/* .Trans */ .cC, {
                      id: "menu_add_playlist.add",
                      message: "Add to Playlist" }) }) }), /*#__PURE__*/



                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(EnhancedBody, { my: 10, children: [
                  userPlaylists.data.map(function (playlist) {
                    var isVideoInPlaylist = playlist.videos.some(
                    function (video) {return video.id === props.videoId;});

                    return /*#__PURE__*/(
                      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {

                        justifyContent: 'space-between',
                        alignItems: 'center',
                        my: '5px',
                        pr: ['25px', '25px', '50px'], children: [/*#__PURE__*/


                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(Checkbox, {
                          onChange: function onChange() {
                            isVideoInPlaylist ?
                            handleRemoveVideoFromPlaylist(playlist.id) :
                            handleAddVideoToPlaylist(playlist.id);
                          },
                          isChecked: isVideoInPlaylist, children:


                          playlist.title }),


                        ICON(playlist.visibility)] }, playlist.id));


                  }),
                  userPlaylists.totalCount / PERPAGE > userPlaylists.page && /*#__PURE__*/
                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                    alignItems: 'center',
                    justifyContent: 'center',
                    my: '5px',
                    pr: ['25px', '25px', '50px'], children: /*#__PURE__*/

                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                      onClick: handleShowMore,
                      style: { fontSize: '13px' },
                      disabled: fetching, children: "Show More" }) })] }), /*#__PURE__*/







                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(ModalButton, { onClick: openPlaylistModal, children: /*#__PURE__*/
                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_TextWithIcon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, { icon: "ygb-icon-playlist", iconSize: "15px", children: /*#__PURE__*/
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_19__/* .Trans */ .cC, {
                      id: "menu_add_playlist.create",
                      message: 'Create new Playlist' }) }) })] }) :




              null] }));} }),



      isOpen ? loginModalContent : null] }));


};

/* harmony default export */ __webpack_exports__["Z"] = (ButtonAddToPlaylist);

/***/ }),

/***/ 35602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ecosystems_ButtonScheduleModal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(63659);
// EXTERNAL MODULE: ./organisms/modals/LoginModal.tsx
var LoginModal = __webpack_require__(77495);
// EXTERNAL MODULE: ./components/TextWithIcon.js
var TextWithIcon = __webpack_require__(64370);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/file-saver/FileSaver.js
var FileSaver = __webpack_require__(78598);
var FileSaver_default = /*#__PURE__*/__webpack_require__.n(FileSaver);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 41 modules
var parse = __webpack_require__(35337);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./components/buttons.js
var buttons = __webpack_require__(49613);
// EXTERNAL MODULE: ./components/Divider.js
var Divider = __webpack_require__(48740);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./components/typography/Headings.tsx
var Headings = __webpack_require__(94268);
// EXTERNAL MODULE: ./organisms/modals/base/index.tsx + 3 modules
var base = __webpack_require__(10842);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/sv/index.js + 5 modules
var sv = __webpack_require__(15155);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./lib/contexts/languageContext.js
var languageContext = __webpack_require__(17516);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./organisms/modals/schedule/DatePicker.tsx







var Wrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "DatePicker__Wrapper", componentId: "sc-17a60z6-0" })([".react-datepicker{font-family:'Libre Franklin',sans-serif;width:100%;border:0;.react-datepicker__header{background-color:white;border-bottom:none;}.react-datepicker__day-name{font-weight:600;color:#5d5d5d;}.react-datepicker__month-container{width:100%;}.react-datepicker__day-names,.react-datepicker__week{display:flex;}.react-datepicker__day-name,.react-datepicker__day,.react-datepicker__time-name{font-size:13px;transition:all 200ms ease;width:100%;}.react-datepicker__day{line-height:35px;}.react-datepicker__day--selected,.react-datepicker__day--in-selecting-range,.react-datepicker__day--in-range{background:none;border-radius:50%;transition:all 300ms ease;font-weight:bold;position:relative;z-index:0;&:hover{background:none;color:white;&:before{background-color:#56b9e5;color:white;}}&:before{content:'';position:absolute;border-radius:50%;background-color:#56b9e5;top:0;left:calc(50% - 17px);width:35px;height:35px;z-index:-1;}&.react-datepicker__day--today{text-decoration:none;}}.react-datepicker__day--outside-month{color:#a1a1a1;&.react-datepicker__day--selected{color:white;}}.react-datepicker__day--today{text-decoration:underline;}.react-datepicker__current-month{margin-bottom:1em;font-weight:normal;}}"]);

























































































var DatePicker = function DatePicker(_ref) {var _ref$handleChange = _ref.handleChange,handleChange = _ref$handleChange === void 0 ? null : _ref$handleChange;
  var locale = (0,react.useContext)(languageContext/* default */.Z);
  var _useState = (0,react.useState)((0,addDays/* default */.Z)(new Date(), 1)),startDate = _useState[0],setStartDate = _useState[1];

  var onChange = function onChange(date) {
    setStartDate(date);
    handleChange === null || handleChange === void 0 ? void 0 : handleChange(date);
  };

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(Wrapper, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)("link", { rel: "stylesheet", href: "/static/css/react-datepicker.css" }), /*#__PURE__*/
      (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
        locale: locale === 'en' ? 'en-US' : sv/* default */.Z,
        selected: startDate,
        onChange: onChange,
        useWeekdaysShort: false,
        inline: true })] }));



};

/* harmony default export */ var schedule_DatePicker = (DatePicker);
// EXTERNAL MODULE: ./components/form/Label.js
var Label = __webpack_require__(25077);
;// CONCATENATED MODULE: ./organisms/modals/schedule/TimePicker.js
function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = (0,getPrototypeOf/* default */.Z)(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return (0,possibleConstructorReturn/* default */.Z)(this, result);};}function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}





var Select = styled_components_browser_esm["default"].select.withConfig({ displayName: "TimePicker__Select", componentId: "sc-1qwowt8-0" })(["background-color:#eeeeee;border:1px solid #eeeeee;border-radius:3px;font-size:16px;padding:10px 0px;"]);var







TimePicker = /*#__PURE__*/function (_Component) {(0,inherits/* default */.Z)(TimePicker, _Component);var _super = _createSuper(TimePicker);
  function TimePicker(props) {var _this;(0,classCallCheck/* default */.Z)(this, TimePicker);
    _this = _super.call(this, props);(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "handleTime",























    function (e) {
      _this.setState({ startTime: e.target.value }, function () {
        _this.props.handleChange(_this.state.startTime);
      });
    });var times = function times() {var t = [];for (var i = 0; i < 24; i++) {var h = i.toString();if (h.length === 1) {t.push({ h: h, time: "0".concat(h, ":00"), zulu: "0".concat(h, "00") });t.push({ h: h, time: "0".concat(h, ":30"), zulu: "0".concat(h, "30") });} else {t.push({ h: h, time: "".concat(h, ":00"), zulu: "".concat(h, "00") });t.push({ h: h, time: "".concat(h, ":30"), zulu: "".concat(h, "30") });}}return t;};_this.state = { times: times(), startTime: '1700' };return _this;}(0,createClass/* default */.Z)(TimePicker, [{ key: "render", value:

    function render() {
      return /*#__PURE__*/(
        (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, { alignItems: "center", children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(Grid/* Box */.xu, { children: /*#__PURE__*/
            (0,jsx_runtime.jsxs)(Label/* default */.Z, { children: [/*#__PURE__*/
              (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "schedule_modal.time", message: 'Time' }), ":"] }) }), /*#__PURE__*/


          (0,jsx_runtime.jsx)(Grid/* Box */.xu, { ml: 10, children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(Select, { onChange: this.handleTime, value: this.state.startTime, children:
              this.state.times.map(function (time, i) {
                return /*#__PURE__*/(
                  (0,jsx_runtime.jsx)("option", { value: time.zulu, children:
                    time.time }, i));


              }) }) })] }));




    } }]);return TimePicker;}(react.Component);


/* harmony default export */ var schedule_TimePicker = (TimePicker);
// EXTERNAL MODULE: ./lib/analytics/manager.ts + 4 modules
var manager = __webpack_require__(88224);
;// CONCATENATED MODULE: ./organisms/modals/schedule/ScheduleModal.js
function ScheduleModal_createSuper(Derived) {var hasNativeReflectConstruct = ScheduleModal_isNativeReflectConstruct();return function _createSuperInternal() {var Super = (0,getPrototypeOf/* default */.Z)(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return (0,possibleConstructorReturn/* default */.Z)(this, result);};}function ScheduleModal_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}












var H4 = (0,styled_components_browser_esm["default"])(Headings.H4).withConfig({ displayName: "ScheduleModal__H4", componentId: "sc-1q5nr29-0" })(["margin:0;"]);var



ScheduleModal = /*#__PURE__*/function (_Component) {(0,inherits/* default */.Z)(ScheduleModal, _Component);var _super = ScheduleModal_createSuper(ScheduleModal);function ScheduleModal() {var _this;(0,classCallCheck/* default */.Z)(this, ScheduleModal);for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}_this = _super.call.apply(_super, [this].concat(args));(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state",
    {
      startDate: (0,addDays/* default */.Z)(new Date(), 1),
      startTime: '1700',
      loadingIcalendar: false,
      loadingGoogle: false,
      open: false });(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "handleOpenModal",


    function () {
      (0,manager/* default */.Z)().sendClickedScheduleEvent({
        videoId: _this.props.resourceId });

      _this.setState({
        open: true });

    });(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "handleCloseModal",

    function () {var _this$props, _this$props$onModalCl;
      _this.setState({
        open: false });

      (_this$props = _this.props) === null || _this$props === void 0 ? void 0 : (_this$props$onModalCl = _this$props.onModalClose) === null || _this$props$onModalCl === void 0 ? void 0 : _this$props$onModalCl.call(_this$props);
    });(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "addVideoToSchedule", /*#__PURE__*/function () {var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(

      function _callee(_ref) {var returnFormat, datetime, _yield$_this$props$ha, data, blob;return regenerator_default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:returnFormat = _ref.returnFormat;_context.prev = 1;

                datetime = (0,parse/* default */.Z)(
                (0,format/* default */.Z)(_this.state.startDate, 'yyyyMMdd') + 'T' + _this.state.startTime,
                "yyyyMMdd'T'HHmm",
                new Date()).
                toISOString();_context.next = 5;return (

                  _this.props.handleSchedule({
                    datetime: datetime,
                    returnFormat: returnFormat }));case 5:_yield$_this$props$ha = _context.sent;data = _yield$_this$props$ha.data;


                if (returnFormat === 'icalendar_file') {
                  blob = new Blob([data.addUserSchedule], {
                    type: 'text/calendar' });

                  FileSaver_default().saveAs(blob, 'ScheduledVideo.ics');
                  _this.setState({ loadingIcalendar: false });
                } else {
                  // let windowRef;
                  // windowRef = window.open();
                  // windowRef.location = data.addUserSchedule;
                  window.open(data.addUserSchedule.result, '_blank');
                  _this.setState({ loadingGoogle: false });
                }_context.next = 13;break;case 10:_context.prev = 10;_context.t0 = _context["catch"](1);

                _this.setState({ loadingIcalendar: false, loadingGoogle: false });case 13:case "end":return _context.stop();}}}, _callee, null, [[1, 10]]);}));return function (_x) {return _ref2.apply(this, arguments);};}());return _this;}(0,createClass/* default */.Z)(ScheduleModal, [{ key: "render", value:



    function render() {var _this2 = this;
      return /*#__PURE__*/(
        (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
          (0,jsx_runtime.jsxs)(base/* Modal */.u_, { open: this.state.open, handleClose: this.handleCloseModal, children: [/*#__PURE__*/
            (0,jsx_runtime.jsx)(base/* Header */.h4, { handleClose: this.handleCloseModal, children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(H4, { children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "schedule_modal.title", message: 'Schedule' }) }) }), /*#__PURE__*/


            (0,jsx_runtime.jsxs)(base/* Body */.uT, { children: [/*#__PURE__*/
              (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: 30, children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(schedule_DatePicker, {
                  handleChange: function handleChange(value) {
                    _this2.setState({
                      startDate: value });

                  } }) }), /*#__PURE__*/


              (0,jsx_runtime.jsx)(Grid/* Box */.xu, { as: Divider/* default */.Z, mb: 30 }), /*#__PURE__*/
              (0,jsx_runtime.jsx)(Grid/* Box */.xu, { children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(schedule_TimePicker, {
                  handleChange: function handleChange(value) {
                    _this2.setState({
                      startTime: value });

                  } }) })] }), /*#__PURE__*/



            (0,jsx_runtime.jsxs)(base/* Footer */.$_, { children: [/*#__PURE__*/
              (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: 10, width: 1, children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(buttons/* default */.ZP, {
                  appearance: "outline",
                  fullWidth: true,
                  loading: this.state.loadingIcalendar,
                  onClick: function onClick() {
                    _this2.setState({ loadingIcalendar: true });
                    _this2.addVideoToSchedule({
                      returnFormat: 'icalendar_file' });

                  }, children: /*#__PURE__*/

                  (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "schedule_modal.icp", message: 'EXPORT .ICS' }) }) }), /*#__PURE__*/


              (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: 10, width: 1, children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(buttons/* default */.ZP, {
                  fullWidth: true,
                  loading: this.state.loadingGoogle,
                  spinnerColor: 'white',
                  onClick: function onClick() {
                    _this2.setState({ loadingGoogle: true });
                    _this2.addVideoToSchedule({
                      returnFormat: 'google_url' });

                  }, children: /*#__PURE__*/

                  (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                    id: "schedule_modal.googlecalendar",
                    message: 'EXPORT TO GOOGLE CALENDAR' }) }) })] })] }),





          this.props.children(this.handleOpenModal)] }));


    } }]);return ScheduleModal;}(react.Component);

/* harmony default export */ var schedule_ScheduleModal = (ScheduleModal);
// EXTERNAL MODULE: ./lib/contexts/UserProvider.tsx
var UserProvider = __webpack_require__(47493);
;// CONCATENATED MODULE: ./ecosystems/ButtonScheduleModal.tsx
var _templateObject;function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}








var ADD_VIDEO_TO_SCHEDULE = (0,lib/* default */.ZP)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation addUserSchedule(\n    $resourceId: ID!\n    $datetime: ISO8601DateTime!\n    $returnFormat: String!\n  ) {\n    addUserSchedule(\n      resourceId: $resourceId\n      datetime: $datetime\n      returnFormat: $returnFormat\n    ) {\n      result\n      filename\n    }\n  }\n"])));
















var ButtonScheduleModal = function ButtonScheduleModal(props) {
  var _useContext = (0,react.useContext)(UserProvider/* UserContext */.S),currentUser = _useContext[0],loading = _useContext[1].loading;

  var DynamicComponent = props.tag;
  if (loading) return null;

  if (!(currentUser !== null && currentUser !== void 0 && currentUser.id)) {
    return /*#__PURE__*/(
      (0,jsx_runtime.jsx)(LoginModal/* default */.Z, { children:
        function children(handleOpenModal) {return /*#__PURE__*/(
            (0,jsx_runtime.jsx)(DynamicComponent, _objectSpread(_objectSpread({
              className: props.className,
              onClick: handleOpenModal },
            props.tagParams), {}, { children: /*#__PURE__*/

              (0,jsx_runtime.jsx)(TextWithIcon/* default */.Z, { icon: "ygb-icon-calendar-o", iconSize: "15px", children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "menu_more.schedule", message: 'Schedule' }) }) })));} }));





  }

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Mutation/* Mutation */.m, { mutation: ADD_VIDEO_TO_SCHEDULE, children:
      function children(addUserSchedule) {return /*#__PURE__*/(
          (0,jsx_runtime.jsx)(schedule_ScheduleModal, {
            resourceId: props.resourceId,
            onModalClose: props.onModalClose,
            handleSchedule: function handleSchedule(_ref) {var datetime = _ref.datetime,returnFormat = _ref.returnFormat;
              return addUserSchedule({
                variables: {
                  resourceId: props.resourceId,
                  datetime: datetime,
                  returnFormat: returnFormat } });


            }, children:

            function children(handleOpenModal) {return /*#__PURE__*/(
                (0,jsx_runtime.jsx)(DynamicComponent, _objectSpread(_objectSpread({
                  className: props.className,
                  onClick: handleOpenModal },
                props.tagParams), {}, { children: /*#__PURE__*/

                  (0,jsx_runtime.jsx)(TextWithIcon/* default */.Z, { icon: "ygb-icon-calendar-o", iconSize: "15px", children: /*#__PURE__*/
                    (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "menu_more.schedule", message: "Schedule" }) }) })));} }));} }));







};

/* harmony default export */ var ecosystems_ButtonScheduleModal = (ButtonScheduleModal);

/***/ }),

/***/ 21158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ PlaylistFavoriting; },
/* harmony export */   "l": function() { return /* binding */ VideoFavoriting; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17674);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4730);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90116);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71383);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(94471);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12922);
/* harmony import */ var _lib_apollo_policies__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54734);
/* harmony import */ var _lib_hooks_useLoginModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73074);
/* harmony import */ var _lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47493);
/* harmony import */ var _gql_generated__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48354);
/* harmony import */ var _lib_analytics_manager__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88224);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);
var _excluded = ["videoId"],_excluded2 = ["playlistId"];var _templateObject;function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}









var GET_CURRENT_USER_FAVORITES = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(["\n  query currentUser {\n    currentUser {\n      id\n      favorites {\n        playlists\n        videos\n      }\n    }\n  }\n"])));











/**
 * The Logic of these 4's should be refactored
 */
var updateUnfavoriteVideo = function updateUnfavoriteVideo(proxy, videoId) {
  var data = proxy.readQuery({
    query: GET_CURRENT_USER_FAVORITES });


  proxy.writeQuery({
    query: GET_CURRENT_USER_FAVORITES,
    data: {
      currentUser: _objectSpread(_objectSpread({},
      data.currentUser), {}, {
        favorites: _objectSpread(_objectSpread({},
        data.currentUser.favorites), {}, {
          videos: data.currentUser.favorites.videos.filter(
          function (id) {return id !== videoId;}) }) }) } });





};

var updateFavoriteVideo = function updateFavoriteVideo(proxy, videoId) {
  var data = proxy.readQuery({
    query: GET_CURRENT_USER_FAVORITES });


  proxy.writeQuery({
    query: GET_CURRENT_USER_FAVORITES,
    data: {
      currentUser: _objectSpread(_objectSpread({},
      data.currentUser), {}, {
        favorites: _objectSpread(_objectSpread({},
        data.currentUser.favorites), {}, {
          videos: [].concat((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(data.currentUser.favorites.videos), [videoId]) }) }) } });




};

var updateUnfavoritePlaylist = function updateUnfavoritePlaylist(
proxy,
playlistId)
{
  var data = proxy.readQuery({
    query: GET_CURRENT_USER_FAVORITES });


  proxy.writeQuery({
    query: GET_CURRENT_USER_FAVORITES,
    data: {
      currentUser: _objectSpread(_objectSpread({},
      data.currentUser), {}, {
        favorites: _objectSpread(_objectSpread({},
        data.currentUser.favorites), {}, {
          playlists: data.currentUser.favorites.playlists.filter(
          function (id) {return id !== playlistId;}) }) }) } });





};

var updateFavoritePlaylist = function updateFavoritePlaylist(
proxy,
playlistId)
{
  var data = proxy.readQuery({
    query: GET_CURRENT_USER_FAVORITES });


  proxy.writeQuery({
    query: GET_CURRENT_USER_FAVORITES,
    data: {
      currentUser: _objectSpread(_objectSpread({},
      data.currentUser), {}, {
        favorites: _objectSpread(_objectSpread({},
        data.currentUser.favorites), {}, {
          playlists: [].concat((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(data.currentUser.favorites.playlists), [playlistId]) }) }) } });




};

var VideoFavoriting = function VideoFavoriting(_ref) {var _currentUser$favorite, _currentUser$favorite2;var videoId = _ref.videoId,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_ref, _excluded);
  var _useLoginModal = (0,_lib_hooks_useLoginModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}),_useLoginModal2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_useLoginModal, 2),loginModalContent = _useLoginModal2[0],openModal = _useLoginModal2[1].openModal;
  var _useDeleteFavoriteVid =


  (0,_gql_generated__WEBPACK_IMPORTED_MODULE_6__/* .useDeleteFavoriteVideoMutation */ .ygI)(),_useDeleteFavoriteVid2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_useDeleteFavoriteVid, 2),deleteFavoriteVideo = _useDeleteFavoriteVid2[0],deleteFavoriteVideoLoading = _useDeleteFavoriteVid2[1].loading;
  var _useAddFavoriteVideoM =


  (0,_gql_generated__WEBPACK_IMPORTED_MODULE_6__/* .useAddFavoriteVideoMutation */ .Gxw)(),_useAddFavoriteVideoM2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_useAddFavoriteVideoM, 2),addFavoriteVideo = _useAddFavoriteVideoM2[0],addFavoriteVideoLoading = _useAddFavoriteVideoM2[1].loading;
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_5__/* .UserContext */ .S),currentUser = _useContext[0],_useContext$ = _useContext[1],loading = _useContext$.loading,error = _useContext$.error;

  if (error || loading || currentUser === undefined) {
    return null;
  }

  var handlingFavoritingVideo = /*#__PURE__*/function () {var _ref2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(
    isFavoritedVideoById,
    addFavoriteVideo,
    deleteFavoriteVideo) {return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!

              isFavoritedVideoById) {_context.next = 5;break;}_context.next = 3;return (
                deleteFavoriteVideo({
                  variables: {
                    videoId: videoId },

                  // TODO: handle failed case
                  update: function update(proxy) {return updateUnfavoriteVideo(proxy, videoId);} }));case 3:_context.next = 8;break;case 5:


              (0,_lib_analytics_manager__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().sendVideoAddedToFavorites({ video_id: videoId });

              // TODO: handle failed case
              _context.next = 8;return addFavoriteVideo({
                variables: {
                  videoId: videoId },

                // TODO: handle failed case
                update: function update(proxy) {
                  updateFavoriteVideo(proxy, videoId);
                } });case 8:case "end":return _context.stop();}}}, _callee);}));return function handlingFavoritingVideo(_x, _x2, _x3) {return _ref2.apply(this, arguments);};}();




  var isFavoritedVideoById = currentUser ?
  currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$favorite = currentUser.favorites) === null || _currentUser$favorite === void 0 ? void 0 : (_currentUser$favorite2 = _currentUser$favorite.videos) === null || _currentUser$favorite2 === void 0 ? void 0 : _currentUser$favorite2.includes(videoId) :
  false;

  var onClickFavoriteHandler = /*#__PURE__*/function () {var _ref3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:if (
              currentUser) {_context2.next = 4;break;}
              openModal();_context2.next = 7;break;case 4:_context2.next = 6;return (

                handlingFavoritingVideo(
                isFavoritedVideoById,
                addFavoriteVideo,
                deleteFavoriteVideo));case 6:

              (0,_lib_apollo_policies__WEBPACK_IMPORTED_MODULE_3__/* .snackbarVar */ .Ck)({
                isSnackBarOpen: true,
                goTo: 'FAVORITES',
                id: 'favorites_2',
                snackBarMessage: isFavoritedVideoById ? /*i18n*/
                _lingui_core__WEBPACK_IMPORTED_MODULE_15__/* .i18n._ */ .ag._("snackbars.unfavorited_video") : /*i18n*/
                _lingui_core__WEBPACK_IMPORTED_MODULE_15__/* .i18n._ */ .ag._("snackbars.favorited_video") });case 7:case "end":return _context2.stop();}}}, _callee2);}));return function onClickFavoriteHandler() {return _ref3.apply(this, arguments);};}();




  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, { children: [
      loginModalContent,
      props.children({
        isFavoritedVideoById: isFavoritedVideoById,
        onClickFavoriteHandler: onClickFavoriteHandler,
        loading: deleteFavoriteVideoLoading || addFavoriteVideoLoading })] }));



};

var PlaylistFavoriting = function PlaylistFavoriting(_ref4) {var _currentUser$favorite3;var playlistId = _ref4.playlistId,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_ref4, _excluded2);
  var _useLoginModal3 = (0,_lib_hooks_useLoginModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}),_useLoginModal4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_useLoginModal3, 2),loginModalContent = _useLoginModal4[0],openModal = _useLoginModal4[1].openModal;
  var _useDeleteFavoritePla =


  (0,_gql_generated__WEBPACK_IMPORTED_MODULE_6__/* .useDeleteFavoritePlaylistMutation */ .w3$)(),_useDeleteFavoritePla2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_useDeleteFavoritePla, 2),deleteFavoritePlaylist = _useDeleteFavoritePla2[0],deleteFavoritePlaylistLoading = _useDeleteFavoritePla2[1].loading;
  var _useAddFavoritePlayli =


  (0,_gql_generated__WEBPACK_IMPORTED_MODULE_6__/* .useAddFavoritePlaylistMutation */ .pAI)(),_useAddFavoritePlayli2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_useAddFavoritePlayli, 2),addFavoritePlaylist = _useAddFavoritePlayli2[0],addFavoritePlaylistLoading = _useAddFavoritePlayli2[1].loading;
  var _useContext2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_5__/* .UserContext */ .S),currentUser = _useContext2[0],_useContext2$ = _useContext2[1],loading = _useContext2$.loading,error = _useContext2$.error;

  if (error || loading) {
    return null;
  }

  var handlingFavoritingPlaylist = /*#__PURE__*/function () {var _ref5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(
    isPlaylistFavoritedById,
    addFavoritePlaylist,
    deleteFavoritePlaylist) {return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:if (!

              isPlaylistFavoritedById) {_context3.next = 5;break;}_context3.next = 3;return (

                deleteFavoritePlaylist({
                  variables: {
                    playlistId: playlistId },

                  // TODO: handle failed case
                  update: function update(proxy) {return updateUnfavoritePlaylist(proxy, playlistId);} }));case 3:_context3.next = 8;break;case 5:


              (0,_lib_analytics_manager__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().sendPlaylistAddedToFavorites({
                playlist_id: playlistId });

              // PLAYLIST TODO: handle errors
              _context3.next = 8;return addFavoritePlaylist({
                variables: {
                  playlistId: playlistId },

                // TODO: handle failed case
                update: function update(proxy) {
                  updateFavoritePlaylist(proxy, playlistId);
                } });case 8:case "end":return _context3.stop();}}}, _callee3);}));return function handlingFavoritingPlaylist(_x4, _x5, _x6) {return _ref5.apply(this, arguments);};}();




  var isPlaylistFavoritedById = currentUser ?
  currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$favorite3 = currentUser.favorites) === null || _currentUser$favorite3 === void 0 ? void 0 : _currentUser$favorite3.playlists.includes(playlistId) :
  false;

  var onClickFavoriteHandler = /*#__PURE__*/function () {var _ref6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:if (
              currentUser) {_context4.next = 4;break;}
              // show login modal
              openModal();_context4.next = 7;break;case 4:_context4.next = 6;return (

                handlingFavoritingPlaylist(
                isPlaylistFavoritedById,
                addFavoritePlaylist,
                deleteFavoritePlaylist));case 6:


              (0,_lib_apollo_policies__WEBPACK_IMPORTED_MODULE_3__/* .snackbarVar */ .Ck)({
                isSnackBarOpen: true,
                goTo: 'FAVORITES',
                id: 'favorites_1',
                snackBarMessage: isPlaylistFavoritedById ? /*i18n*/
                _lingui_core__WEBPACK_IMPORTED_MODULE_15__/* .i18n._ */ .ag._("snackbars.unfavorited_playlist") : /*i18n*/
                _lingui_core__WEBPACK_IMPORTED_MODULE_15__/* .i18n._ */ .ag._("snackbars.favorited_playlist") });case 7:case "end":return _context4.stop();}}}, _callee4);}));return function onClickFavoriteHandler() {return _ref6.apply(this, arguments);};}();




  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, { children: [
      loginModalContent,
      props.children({
        isPlaylistFavoritedById: isPlaylistFavoritedById,
        onClickFavoriteHandler: onClickFavoriteHandler,
        loading: deleteFavoritePlaylistLoading || addFavoritePlaylistLoading })] }));



};

/***/ }),

/***/ 5822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85169);
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37702);
/* harmony import */ var _components_TextWithIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64370);
/* harmony import */ var _organisms_modals_ShareModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29382);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
var _excluded = ["className"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}














var MenuItemShareModal = function MenuItemShareModal(props, ref) {
  var className = props.className,otherProps = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, _excluded);
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_organisms_modals_ShareModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, otherProps), {}, { children:
      function children(handleOpenModal) {return /*#__PURE__*/(
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, { ref: ref, onClick: handleOpenModal, children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_TextWithIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              className: className,
              icon: "ygb-icon-share",
              iconSize: "15px", children: /*#__PURE__*/

              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "menu_more.share", message: "Share" }) }) }));} })));





};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(MenuItemShareModal));

/***/ }),

/***/ 73074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77495);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
var _excluded = ["open"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var useLoginModal = function useLoginModal()


{var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var _ref$open = _ref.open,open = _ref$open === void 0 ? false : _ref$open,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(open),isOpen = _useState[0],setOpen = _useState[1];

  var content = /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, props), {}, { open: isOpen, onClose: function onClose() {return setOpen(false);} }));


  return [
  content,
  {
    isOpen: isOpen,
    openModal: function openModal() {return setOpen(true);},
    closeModal: function closeModal() {return setOpen(false);} }];


};

/* harmony default export */ __webpack_exports__["Z"] = (useLoginModal);

/***/ })

}]);